// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://obeogkrdszdkvrashtyp.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9iZW9na3Jkc3pka3ZyYXNodHlwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3OTU0MzYsImV4cCI6MjA2OTM3MTQzNn0.rNpgCRXnLNNeyu15nlPR9qMwkZO9oZqddY0iC33mc0o";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});